import './styles/tokens.css'

import { entryFromPath, suppressInstallPrompt } from '@/app/entry-path'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element #root is missing from index.html')
}

/*
 * Two apps share this bundle, and which one a page load is gets decided here,
 * once, before either is imported.
 *
 * Both branches are dynamic imports, and that is the point: a static import is
 * hoisted into this entry chunk whichever branch runs. A customer who scans a
 * table QR (`/t/<token>`, table-ordering-v1 §7) downloads the table page and
 * the primitives it uses — not the till's router, session, order stream or
 * service worker.
 *
 * It is not a route in the till's router because that cannot keep the till
 * out of the download: `routeTree.gen.ts` imports every route module, the
 * router plugin only splits a route's components (its `beforeLoad` guards stay
 * in the main chunk, and they import the auth slice), and `__root.tsx` imports
 * the orders and auth slices at module level.
 *
 * The till pays one extra hop on a cold, uncached start (this file, then the
 * till chunk); a till running from its service worker's precache does not.
 */
const entry = entryFromPath(window.location.pathname)

if (entry.app === 'till') {
  void import('@/app/till-shell').then(({ mountTill }) => {
    mountTill(rootElement)
  })
} else {
  // Before the import, not in the shell: see `suppressInstallPrompt`.
  suppressInstallPrompt()
  void import('@/app/table-shell').then(({ mountTableOrder }) => {
    mountTableOrder(rootElement, entry.token)
  })
}
